import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./_text-editor.scss";

const TextEditor = ({
  textEditorValue,
  setTextEditorValue,
  placeholder,
  disabled,
}) => {
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "link",
  ];
  return (
    <div
      className={`text-editor-wrapper ${
        disabled ? "text-editor-wrapper-disabled" : ""
      }`}
    >
      <ReactQuill
        formats={formats}
        modules={modules}
        placeholder={placeholder}
        value={textEditorValue}
        onChange={setTextEditorValue}
        readOnly={disabled}
      />
    </div>
  );
};

export default TextEditor;
